import { memo } from 'react';
import { Alert, Button, SpaceBetween } from '@amzn/awsui-components-core';

import styles from './FatalErrorOverlay.module.scss';

interface FatalErrorOverlayProps {
  readonly message: string;
}

/**
 * Full-screen, non-dismissible overlay shown when the app has hit an
 * unrecoverable error. The only action offered is to reload the page.
 */
export const FatalErrorOverlay = memo(function FatalErrorOverlay({
  message,
}: FatalErrorOverlayProps) {
  // Reload is the only way out; the overlay blocks all other interaction.
  const handleReload = () => window.location.reload();

  return (
    <div className={styles.backdrop} role="alertdialog" aria-modal="true">
      <div className={styles.content}>
        <Alert type="error" header="Something went wrong">
          <SpaceBetween size="s">
            {message}

            <Button variant="inline-link" onClick={handleReload}>
              Reload page
            </Button>
          </SpaceBetween>
        </Alert>
      </div>
    </div>
  );
});
